<template>
  <div class="padded">

    <h2>Stale Requests</h2>
    <el-alert title="Note:" description="These are request steps with no files uploaded."   show-icon :closable="false" />
<!--       :sort-field="['actionType', 'fileTitle', 'siteName', 'requestor']" -->

    <data-table
      title="Stale Requests"
      :url="'/report/requests/stale' + (this.isTelco() ? '/' + this.org().id : '')"
      :show-search="false"
      :fields="['actionType', 'fileTitle', 'siteName', 'requestor', 'email', 'phone', 'targetDate', 'updated_at']"
      />
  </div>
</template>


<script>

export default {

}

</script>



// WEBPACK FOOTER //
// StaleRequestReport.vue?0b4bc693